module.exports = __webpack_public_path__ + "static/faro-images-1-ee3ff90e817a0cae8fe324d1f408a9e7.jpg";